// 로컬 정의로 대체 (figma_ref 제거)
const paths = {
  p328a5f80: "M6.6668 2.66641H4.00013C3.64651 2.66641 3.30737 2.80688 3.05732 3.05693C2.80727 3.30698 2.6668 3.64612 2.6668 3.99974V11.9997C2.6668 12.3534 2.80727 12.6925 3.05732 12.9425C3.30737 13.1926 3.64651 13.3331 4.00013 13.3331H12.0001C12.3538 13.3331 12.6929 13.1926 12.9429 12.9425C13.193 12.6925 13.3335 12.3534 13.3335 11.9997V9.33307M8.00013 7.99974L13.3335 2.66641M13.3335 2.66641V5.99974M13.3335 2.66641H10.0001",
};

export default paths;
